import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['SM', 'S.M.', 'ESL Teacher — London, United Kingdom', '“I no longer spend my Sunday nights building lessons from scratch. I open the system, choose the lesson, and walk in completely prepared.”'], ['CV', 'C.V.', 'ESL Instructor — Toronto, Canada', '“The emergency lessons alone saved me three times in the first month. That bonus is worth the entire price on its own.”'], ['JR', 'J.R.', 'ESL Teacher — Sydney, Australia', '“The grammar guide changed how I explain structures completely. My students understand faster, and I never blank in class anymore.”']];
export function TestimonialsStrip() {
  return <section className="bg-cream px-4 py-14" data-id="element-227">
      <div className="mx-auto grid max-w-7xl gap-5 md:grid-cols-3" data-id="element-228">
        {testimonials.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="rounded-2xl border border-[#e6d9b7] bg-white p-6 shadow-card" data-id="element-229">
            <div className="mb-4 flex gap-1 text-gold-300" data-id="element-230">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} size={15} fill="currentColor" data-id="element-231" />)}
            </div>
            <p className="min-h-24 text-sm leading-6 text-slate-600 italic" data-id="element-232">
              {quote}
            </p>
            <div className="mt-6 flex items-center gap-3" data-id="element-233">
              <span className="grid h-10 w-10 place-items-center rounded-full bg-navy-900 text-sm font-extrabold text-gold-300" data-id="element-234">
                {initials}
              </span>
              <div data-id="element-235">
                <p className="text-sm font-extrabold text-navy-950" data-id="element-236">{name}</p>
                <p className="text-xs font-semibold text-navy-700" data-id="element-237">{role}</p>
              </div>
            </div>
          </motion.article>)}
      </div>
    </section>;
}